import imageUrlBuilder from '@sanity/image-url'
import { sanity } from '../../clientConfig'

const builder = imageUrlBuilder(sanity)

export function imageUrlFor(source) {
  return builder.image(buildImageObj(source) || source.asset)
}

function getAssetDimensions(image) {
  const asset = image?.asset
  const metadataDimensions = asset?.metadata?.dimensions

  if (asset?.width && asset?.height) {
    return {
      width: asset.width,
      height: asset.height,
    }
  }

  if (metadataDimensions?.width && metadataDimensions?.height) {
    return {
      width: metadataDimensions.width,
      height: metadataDimensions.height,
    }
  }

  const ref = asset?._ref || asset?._id
  const dimensions = ref?.match(/-(\d+)x(\d+)-/)

  if (!dimensions) return null

  return {
    width: Number(dimensions[1]),
    height: Number(dimensions[2]),
  }
}

export function getCappedImageDimensions(image, maxWidth, fallback = {}) {
  const dimensions = getAssetDimensions(image)

  if (!dimensions) return fallback

  const width = Math.min(dimensions.width, maxWidth)
  const height = Math.round((width / dimensions.width) * dimensions.height)

  return { width, height }
}

export function buildSanityImageUrl(
  source,
  { width = 1200, height, quality = 75 } = {}
) {
  if (!source?.asset) return null

  const image = imageUrlFor(source)
    .width(width)
    .fit('max')
    .auto('format')
    .quality(quality)

  if (height) image.height(height)

  return image.url()
}

export function buildSanityImageSrcSet(
  source,
  { width, height, widths = [], quality = 75 } = {}
) {
  if (!source?.asset || !width || !widths.length) return null

  return widths
    .filter(srcWidth => srcWidth <= width)
    .map(srcWidth => {
      const srcHeight = height
        ? Math.round((srcWidth / width) * height)
        : undefined

      return `${buildSanityImageUrl(source, {
        width: srcWidth,
        height: srcHeight,
        quality,
      })} ${srcWidth}w`
    })
    .join(', ')
}

export function buildImageObj(source = { asset: {} }) {
  const imageObj = {
    asset: { _ref: source.asset?._ref || source.asset?._id },
  }

  if (!imageObj.asset._ref) return null

  if (source.crop) imageObj.crop = source.crop
  if (source.hotspot) imageObj.hotspot = source.hotspot

  return imageObj
}
